<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t('summary') }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="getSummaryReportSelectedCinema ? 'shift-up':''"
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>
              <b-dropdown
                :text="getSummaryReportSelectedCinema"
                :disabled="isRoleID"
                variant="dropdown-curve"
                class="w-100"
              >
              <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Cinema"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCinema()"
                      v-on:keydown="onSearchCinema()"
                      v-model="searchCinema"
                    />
                  </div>
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="onSummaryReportDropdownHandler({ event: $event, name:'isCinema',selectedItem: dropdownItem, index:dropdownIndex });searchCinema='';onSearchCinema()"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <!-- FETCH BUTTON -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getSummaryReportFromDate"
                  v-on:click="onSummaryReportDateHandler({ event: null, name: 'fromDate' })"
                >✖</button>
                <Datepicker :monday-first="true"
                  @selected="onSummaryReportDateHandler({ event: $event, name: 'fromDate' })"
                  ref="programaticOpen"
                  :value="getSummaryReportFromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getSummaryReportFromDate ? 'active': ''"
                >{{ $t('show') }} {{ $t('fromdate') }}</label>
              </div>
            </div>
          </div>
          <!-- TO DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getSummaryReportToDate"
                  v-on:click="onSummaryReportDateHandler({ event: null, name: 'toDate' })"
                >✖</button>
                <Datepicker :monday-first="true"
                  @selected="onSummaryReportDateHandler({ event: $event, name: 'toDate' })"
                  ref="programaticOpen"
                  :value="getSummaryReportToDate"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getSummaryReportToDate ? 'active': ''"
                >{{ $t('show') }} {{ $t('todate') }}</label>
              </div>
            </div>
          </div>
           <div class="col-lg-6 col-xl-3 align-self-center mb-3">
           <multiselect
                :options="version"
                v-model="selected_version"
                :searchable="true"
                placeholder="Select Version"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
           </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              @click.prevent.stop="submit"
              class="btn-blue-lg w-100"
            >{{ $t('fetch') }} {{ $t('report') }}</button>
          </div>
             <div class="col-lg-6 col-xl-3 align-self-center mb-3"
        v-if="getSummariesPDFFileName"
      >
        <a
          v-if="getSummariesPDFFileName"
          :href="BASE_URL+getSummariesPDFFileName"
          target="_blank"
          download
          class="btn-transparent ml-3"
          title="Download as PDF"
          style="color: #3876d2;"
        ><img src="@/assets/img/icons/download.svg" height="20" width="20"/> Download
        </a>
      </div>
        </div>
      </div>
      <div class="row"></div>

      <table v-if="selected_version == 'v1'" class="summary-report-table" border="1">
        <tr>
          <td>
            <table class="inner-table">
              <thead>
                <td colspan="2" class="py-0">
                  <div
                    class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
                  >{{ $t('summary') }}</div>
                </td>
              </thead>
              <tr>
                <td>{{ $t('total') }} {{ $t('admit') }}:</td>
                <td>{{ getSummaries.TotalAdmits || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('total') }} {{ $t('transactions') }}:</td>
                <td>{{ getSummaries.TotalTransactions || '0' }}</td>
              </tr>
              <tr>
                <td>{{ $t('total') }} {{ $tc('seat', 1) }} {{ $t('in') }} {{ $tc('cinema', 2) }}:</td>
                <td>{{ getSummaries.TotalSeatsInCinema || '0' }}</td>
              </tr>
              <tr>
                <td>{{ $t('total') }} {{ $tc('screen', 2) }}:</td>
                <td>{{ getSummaries.TotalScreens || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('total') }} {{ $t('noof') }} {{ $t('show') }}:</td>
                <td>{{ getSummaries.TotalNoofShows || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('total') }} {{ $t('revenue') }}:</td>
                <td>{{ getSummaries.TotalRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('average') }} {{ $t('show') }}:</td>
                <td>{{ getSummaries.AvgShows.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('average') }} {{ $t('show') }} {{ $t('per') }} {{ $tc('screen', 1) }}:</td>
                <td>{{ getSummaries.AverageShowsPerScreen.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>
              <tr>
                <td>{{ $t('average') }} {{ $t('show') }} {{ $t('per') }} {{ $t('per') }} {{ $t('days') }}:</td>
                <td>{{ getSummaries.AverageShowsPerDayPerScreen.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>
            </table>
          </td>
          <td>
            <table class="inner-table">
              <thead>
                <tr>
                  <td colspan="2" class="py-0">
                    <div
                      class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
                    >{{ $t('boxoffice') }}</div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('boxoffice') }} {{ $t('revenue') }}(BOR):</td>
                  <td>{{ getSummariesBoxOffice.TotalBoxOfficeRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
                </tr>

                <tr>
                  <td>{{ $t('tax') }}:</td>
                  <td>{{ getSummariesBoxOffice.TotalTax.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
                </tr>

                <tr>
                  <td>{{ $t('additionalChanges') }}:</td>
                  <td>{{ getSummariesBoxOffice.AdditionalCharges.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
                </tr>

                <tr>
                  <td>{{ $t('net') }} BOR:</td>
                  <td>{{ getSummariesBoxOffice.NetRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
                </tr>

                <tr>
                  <td>{{ $t('total') }} {{ $t('transactions') }}:</td>
                  <td>{{ getSummariesBoxOffice.TotalTransaction || '0' }}</td>
                </tr>

                <tr>
                  <td>ATP:</td>
                  <td>{{ getSummariesBoxOffice.ATP.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
                </tr>

                <tr>
                  <td>{{ $t('net') }} ATP:</td>
                  <td>{{ getSummariesBoxOffice.NetATP.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
                </tr>

                <tr>
                  <td>{{ $t('occupancy') }} %:</td>
                  <td>{{ getSummariesBoxOffice.OccupancyRate.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <table class="inner-table">
              <thead>
                <tr>
                  <td colspan="2" class="py-0">
                    <div
                      class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
                    >{{ $t('concession') }}</div>
                  </td>
                </tr>
              </thead>
              <tr>
                <td>{{ $t('gross') }} {{ $t('revenue') }}:</td>
                <td>{{ getSummariesConcession.GrossConcessionRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('tax') }}:</td>
                <td>{{ getSummariesConcession.TaxConcessionRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('concession') }} {{ $t('net') }} {{ $t('revenue') }}:</td>
                <td>{{ getSummariesConcession.NetConcessionRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('cost') }} Of {{ $t('goods') }} {{ $t('sold') }}:</td>
                <td>{{ getSummariesConcession.CostOfGoods.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('gross') }} {{ $t('spend') }} {{ $t('per') }} {{ $t('head') }}:</td>
                <td>{{ getSummariesConcession.GrossSpendPerHead.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('transactions') }}:</td>
                <td>{{ getSummariesConcession.NumberOfConcessionsTransactions || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('admission') }} {{ $t('strike') }} {{ $t('rate') }}:</td>
                <td>{{ getSummariesConcession.AdmissionStrikeRate.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('average') }} {{ $t('value') }} {{ $t('per') }} {{ $t('transactions') }}:</td>
                <td>{{ getSummariesConcession.AverageValuePerTransaction.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('quantity') }} of {{ $t('items') }} {{ $t('sold') }}:</td>
                <td>{{ getSummariesConcession.QuantityOfItemsSold || '0' }}</td>
              </tr>
            </table>
            <table style="width:calc(100% - 30px)" border="1" class="mx-auto mb-3">
              <tr>
                <td class="p-1">{{ $t('items') }} {{ $t('name') }}</td>
                <td class="p-1">Qty {{ $t('sold') }}</td>
                <td class="p-1">{{ $t('gross') }} {{ $t('revenue') }}</td>
                <td class="p-1">{{ $t('profit') }} {{ $t('margin') }}</td>
              </tr>
              <tr
                v-for="(items, itemIndex) in getSummariesConcession.TopFiveItemsSold"
                :key="itemIndex"
              >
                <td class="p-1">{{ items.recipe_name }}</td>
                <td class="p-1">{{ items.count }}</td>
                <td class="p-1">{{ (items.fp_total_amount * items.count).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
                <td
                  class="p-1"
                >{{ ((items.fp_total_amount * items.count) - (items.fp_cost_of_item * items.count)).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table class="inner-table">
              <thead>
                <tr>
                  <td colspan="2" class="py-0">
                    <div
                      class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
                    >{{ $t('concession') }} {{ $t('profit') }}</div>
                  </td>
                </tr>
              </thead>
              <tr>
                <td>{{ $t('profit') }} At {{ $t('standard') }} {{ $t('cost') }}:</td>
                <td>{{ getSummariesConcessionProfit.ProfitAtStandardCost.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('average') }} {{ $t('profit') }}:</td>
                <td>{{ getSummariesConcessionProfit.AverageProfit.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('average') }} {{ $t('profit') }} {{ $t('per') }} {{ $t('items') }}:</td>
                <td>{{ getSummariesConcessionProfit.AverageProfitPerItem.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $t('profit') }} {{ $t('per') }} {{ $t('head') }}:</td>
                <td>{{ getSummariesConcessionProfit.ProfitPerHead.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>

              <tr>
                <td>{{ $tc('price', 1) }} {{ $t('per') }} {{ $t('transactions') }}:</td>
                <td>{{ getSummariesConcessionProfit.PricePerTransaction.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</td>
              </tr>
            </table>
          </td>
          <!-- <td>
      <table class="inner-table">
        <thead>
          <tr>
            <td colspan="2" class="py-0">
              <div
              class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
              >Miscellaneous</div>
            </td>
          </tr>
        </thead>
        <tr>
          <td>Total Admits:</td>
          <td>4,170</td>
        </tr>
      </table>
          </td>-->
        </tr>
      </table>

       

      <!-- <div
        v-if="getSummariesPDFFileName"
        class="d-flex justify-content-end mt-5 align-items-center"
      >
        <div>{{ $t('download') }} as:</div>
        <a
          v-if="getSummariesPDFFileName"
          :href="BASE_URL+getSummariesPDFFileName"
          target="_blank"
          download
          class="btn-transparent ml-3"
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>

 
      </div> -->
    </div>
    <div v-if="selected_version == 'v2'" class="row mt-2">
                    <div class="col-lg-6 col-xl-6 mb-4">
                        <div class="reports-box">
                            <div class="d-flex align-items-center justify-content-between pb-2">
                                <div class="title">SUMMARY</div>
                                <div class="text-dark">
                                    <a href="">
                                        <!-- <img src="@/assets/img/icons/download.svg" height="20" width="20"/> -->
                                    </a>
                                    </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <div class="light-title">Total Admits</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Total Transactions</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Total Screens</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{getSummaries.TotalAdmits || '0'}}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{getSummaries.TotalTransactions || '0'}}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{getSummaries.TotalScreens || '0'}}</div>
                                </div>
                                <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Total Seat In Cinema</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Total No Of Show</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Total Revenue</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{getSummaries.TotalSeatsInCinema || '0'}}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{getSummaries.TotalNoofShows || '0'}}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{getSummaries.TotalRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0'}}</div>
                                </div>
                                <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Average Shows</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Average Seats Per Screen</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Average Shows Per Day</div>
                                </div>
                                 <div class="col-4">
                                    <div class="total-dark">{{getSummaries.AvgShows.toFixed(this.MIN_FRACTION_DIGITS) || '0'}}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{getSummaries.AverageShowsPerScreen.toFixed(this.MIN_FRACTION_DIGITS) || '0'}}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{getSummaries.AverageShowsPerDayPerScreen.toFixed(this.MIN_FRACTION_DIGITS) || '0'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-6">
                        <div class="reports-box">
                            <div class="d-flex align-items-center justify-content-between pb-2">
                                <div class="title">BOX OFFICE</div>
                                <div class="text-dark">
                                    <a href="">
                                        <!-- <img src="@/assets/img/icons/download.svg" height="20" width="20"/> -->
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <div class="light-title">Box Office Revenue(BOR)</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Tax</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Additional Charges</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.TotalBoxOfficeRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.TotalTax.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.AdditionalCharges.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Net BOR</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Total Transactions</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">ATP</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.NetRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.TotalTransaction || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.ATP.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Net ATP</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Occupancy %</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title"></div>
                                </div>
                                 <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.NetATP.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.OccupancyRate.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <!-- <div class="col-4">
                                    <div class="total-dark">4</div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-6">
                        <div class="reports-box">
                            <div class="d-flex align-items-center justify-content-between pb-2">
                                <div class="title">{{ $t('concession') }}</div>
                                <div class="text-dark">
                                    <!-- <a href="">
                                        <img src="@/assets/img/icons/download.svg" height="20" width="20"/>
                                    </a> -->
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <div class="light-title">{{ $t('gross') }} {{ $t('revenue') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('tax') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('concession') }} {{ $t('net') }} {{ $t('revenue') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.GrossConcessionRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.TaxConcessionRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.NetConcessionRevenue.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('cost') }} Of {{ $t('goods') }} {{ $t('sold') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('gross') }} {{ $t('spend') }} {{ $t('per') }} {{ $t('head') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('transactions') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.CostOfGoods.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.GrossSpendPerHead.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.NumberOfConcessionsTransactions || '0' }}</div>
                                </div>
                                <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('admission') }} {{ $t('strike') }} {{ $t('rate') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('average') }} {{ $t('value') }} {{ $t('per') }} {{ $t('transactions') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('quantity') }} of {{ $t('items') }} {{ $t('sold') }}</div>
                                </div>
                                 <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.AdmissionStrikeRate.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.AverageValuePerTransaction.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcession.QuantityOfItemsSold || '0' }}</div>
                                </div>
                                 <table style="width:calc(100% - 30px);" border="1" class="item-table mx-auto mb-3">
              <tr>
                <td class="p-1">{{ $t('items') }} {{ $t('name') }}</td>
                <td class="p-1">Qty {{ $t('sold') }}</td>
                <td class="p-1">{{ $t('gross') }} {{ $t('revenue') }}</td>
                <td class="p-1">{{ $t('profit') }} {{ $t('margin') }}</td>
              </tr>
              <tr
                v-for="(items, itemIndex) in getSummariesConcession.TopFiveItemsSold"
                :key="itemIndex"
              >
                <td class="p-1">{{ items.recipe_name }}</td>
                <td class="p-1">{{ items.count }}</td>
                <td class="p-1">{{ (items.fp_total_amount * items.count).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
                <td
                  class="p-1"
                >{{ ((items.fp_total_amount * items.count) - (items.fp_cost_of_item * items.count)).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              </tr>
            </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-6">
                        <div class="reports-box">
                            <div class="d-flex align-items-center justify-content-between pb-2">
                                <div class="title">{{ $t('concession') }} {{ $t('profit') }}</div>
                                <div class="text-dark">
                                    <a href="">
                                        <!-- <img src="@/assets/img/icons/download.svg" height="20" width="20"/> -->
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <div class="light-title">{{ $t('profit') }} At {{ $t('standard') }} {{ $t('cost') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('average') }} {{ $t('profit') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('average') }} {{ $t('profit') }} {{ $t('per') }} {{ $t('items') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcessionProfit.ProfitAtStandardCost.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcessionProfit.AverageProfit.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcessionProfit.AverageProfitPerItem.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('profit') }} {{ $t('per') }} {{ $t('head') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $tc('price', 1) }} {{ $t('per') }} {{ $t('transactions') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title"></div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcessionProfit.ProfitPerHead.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesConcessionProfit.PricePerTransaction.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import { mapState, mapGetters, mapActions } from "vuex";
import { BASEURL } from "@/config/index";
export default {
  data() {
    return {
      summaryFromDate: "",
      summaryToDate: "",
      version: ['v1','v2'],
      selected_version: 'v2',
      isRoleID:true,
      Cinemas : [],
      CinemasCopy: [],
      searchCinema: "",
    };
  },
  computed: {
    ...mapGetters([
      // Flags
      "getCinemasList",
      "getSummaryReportsIsCinema",
      // End
      // DropDownList
      // DropDown
      // Get DropDown Selected Values
      "getSummaryReportFromDate",
      "getSummaryReportSelectedCinema",
      "getSummaryReportToDate",
      // List
      "getSummaries",
      "getSummariesBoxOffice",
      "getSummariesConcession",
      "getSummariesConcessionProfit",
      // PDF
      "getSummariesPDFFileName"
    ])
  },
  beforeMount() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.onSummaryReportFlagHandler({
      event: null,
      name: "isCinema",
      value: cinemaId
    });
    this.onSummaryReportFlagHandler({
      event: null,
      name: "isCountry",
      value: this.secureStore.get("BRGLOPCO") || null
    });
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
      console.log('cinemaId :>> ', cinemaId);
        this.getCinemaList(cinemaId);
    // this.fetchCinemasList({ cinemaId });
  },
  methods: {
     onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
    //  let payload = null
    //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
       MasterService.GetCinemas({cine_id: cine_id})
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
             this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                
               
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };
                
                // this.onSelectCinema(null,cinema);
                // this.onAdvanceBookingReportDropDownHandler({ name:'isCinema',selectedItem: {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // } })

                this.onSummaryReportDropdownHandler({ name:'isCinema',selectedItem: {cine_name: x.cine_name,
                  cine_id: x.cine_id} 
                  })
              
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchSummaryReportList",
      "fetchCinemasList",
      //
      "onSummaryReportDateHandler",
      "onSummaryReportDropdownHandler",
      "onSummaryReportFlagHandler",
      "onResetSummaryStoreState"
    ]),
    submit(){
      if(!this.selected_version){
        this.$toasted.show('Please select version.')
      }else{
      this.fetchSummaryReportList()
      }
    }
  },
  beforeDestroy: async function() {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getSummariesPDFFileName
    });
    await this.onResetSummaryStoreState();
  }
};
</script>

<style>
    .reports-box {
        height: auto;
        padding: 10px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    }

    .reports-box .title {
        color: #3876d2;
        font-weight: bold;
        font-size: 20px;
    }

    .reports-box .light-title {
        font-size: 12px;
        color: #a7a7a7;
    }

    .reports-box .total-dark {
        font-size: 18px;
        color: #000000;
        font-weight: bold;
    }

    table.item-table {
    border-collapse:separate;
    border:solid black 1px;
    border-radius:6px;
    -moz-border-radius:6px;
}

td.item-table, th.item-table {
    border-left:solid black 1px;
    border-top:solid black 1px;
}

th.item-table {
    background-color: blue;
    border-top: none;
}

td.item-table:first-child, th.item-table:first-child {
     border-left: none;
}
</style>



// WEBPACK FOOTER //
// src/components/mobileDashboard/reportSummary.vue